import React from "react";
import { IconDownload } from "@tabler/icons-react";
import { EXPORT_URLS } from "../services/api";

const TIDY_COLUMNS =
`run_id, experiment, case_id, case_content_hash, chief_complaint, classified_cc, graph_id,
system, sut_model, sut_version, emulator_model, rep_index, comm_style, seed, coupling_allowed,
status, n_turns, total_latency_s, per_turn_latency_json, questions_asked_json,
soap_note_json, differential_json, mari_path_trace_ref, created_at`;

const RUNPAIR_COLUMNS =
`case_id, system, comm_style, run_id_a, run_id_b, questions_a_json, questions_b_json,
differential_a_json, differential_b_json`;

export default function Export() {
  return (
    <>
      <div className="page-head"><h2>Export</h2></div>
      <div className="banner ok">
        V1 is capture + store + export. No metrics or models here — question-set Jaccard, element-capture,
        differential Jaccard and the mixed-effects models all run downstream in R on these exports.
      </div>

      <div className="card">
        <h3>Downloads</h3>
        <div className="flex" style={{ marginTop: 8 }}>
          <a className="btn primary sm" href={EXPORT_URLS.tidy()} download="mari_tidy.csv"><IconDownload size={14} /> Tidy CSV (1 row / complete run)</a>
          <a className="btn sm" href={EXPORT_URLS.runPairs()} download="mari_run_pairs.csv"><IconDownload size={14} /> Run-pair CSV (C(n,2) scaffold)</a>
          <a className="btn sm" href={EXPORT_URLS.full()} download="mari_full.json"><IconDownload size={14} /> Full JSON (transcripts + traces)</a>
        </div>
        <div className="muted" style={{ marginTop: 8, fontSize: 12 }}>
          Only <code className="mono">status == complete</code> runs are exported. <code className="mono">mari_path_trace_ref</code> is a
          reference id only — raw node sequences never appear in a published export (§10).
        </div>
      </div>

      <div className="card">
        <label className="f">Tidy export — columns (§5.2)</label>
        <div className="provbox" style={{ background: "#fbfaff", color: "#3a3f52", border: "1px solid var(--line)" }}>{TIDY_COLUMNS}</div>
      </div>

      <div className="card">
        <label className="f">Run-pair scaffold — columns</label>
        <div className="provbox" style={{ background: "#fbfaff", color: "#3a3f52", border: "1px solid var(--line)" }}>{RUNPAIR_COLUMNS}</div>
      </div>
    </>
  );
}
